import { snakeStore, SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';
import { HLRService } from '@hlr/services/HLRService';

const table = snakeStore({
  state: {
    [SORT_COLUMN]: 'created_at',
    [SORT_DIRECTION]: 'desc'
  },
  actions: {
    getData: (_, params) => HLRService.getList(params)
  }
});

export default table;
